import React from 'react';
import { formatDeliveryDate } from '../../services/dateUtils';
import * as mealPlanService from '../../services/mealPlanService';

const ResumeDelivery = ({
    selectedDeliveryDate,
    customerToken,
    nextDeliveryDate,
    onResumeConfirmed,
}) => {
    const handleResumeDelivery = async () => {
        try {
            // Call resume endpoint
            const response = await mealPlanService.resumeDelivery(
                customerToken,
                selectedDeliveryDate,
                nextDeliveryDate
            );

            if (response.data.success) {
                // Notify parent that resume was confirmed
                if (onResumeConfirmed) {
                    onResumeConfirmed();
                }
            }
        } catch (error) {
            console.error('Error resuming delivery:', error);
        }
    };

    return (
        <div style={{
            margin: '10px',
            padding: '10px',
            backgroundColor: '#d1ecf1',
            border: '1px solid #bee5eb',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }}>
            <div>
                <div style={{
                    margin: '0 0 5px 0',
                    color: '#0c5460',
                    fontSize: '14px',
                    fontWeight: '600'
                }}>
                    Delivery Skipped
                </div>
                <p style={{
                    margin: 0,
                    color: '#0c5460',
                    fontSize: '12px'
                }}>
                    {nextDeliveryDate ? (
                        <>
                            This delivery has been skipped until{" "}
                            <strong>{formatDeliveryDate(nextDeliveryDate)}</strong>.
                        </>
                    ) : (
                        "This delivery has been skipped indefinitely."
                    )}
                </p>
            </div>
            <button
                onClick={handleResumeDelivery}
                style={{
                    padding: '10px',
                    backgroundColor: '#28a745',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#218838';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#28a745';
                }}
            >
                Resume Delivery
            </button>
        </div>
    );
};

export default ResumeDelivery;